import SearchBar from "../components/searchBar";
import AboutUs from "../components/AboutUs";
import Articles from "../components/Articles";

const LandingPage = () => {
  return (
    <div>
      <SearchBar />
      <AboutUs />
      <Articles />
    </div>
  );
}

export default LandingPage;